import { wikiPathLabel } from '../shared/wikiFormat';

/**
 * Pure model for the Archived view (#872). No React, no network.
 */

function rowsOf(raw) {
    if (Array.isArray(raw)) return raw;
    if (raw && Array.isArray(raw.categories)) return raw.categories;
    return [];
}

const newestFirst = (a, b) => String(b.archived_at || '').localeCompare(String(a.archived_at || ''));

/**
 * `GET /wiki/categories?include_archived=1` → the archived categories to list,
 * newest first: `{ id, name, archivedAt, parentName, inside: [{ id, name }] }`.
 *
 * A subcategory whose parent is archived too is listed under its parent
 * (`inside`), not as its own row: the server refuses to restore it before the
 * parent (409 `wiki_category_parent_archived`), so it gets no button. The
 * server doesn't say whether it was archived with the parent or before it, so
 * the copy only says "restore {parent} first", which is true either way.
 * A subcategory under a live parent is its own row (`parentName` set).
 */
export function archivedCategoryRows(raw) {
    const rows = rowsOf(raw);
    const byId = new Map(rows.map((row) => [row.category_id, row]));
    const archived = rows.filter((row) => row.archived || row.archived_at);
    return archived
        .filter((row) => {
            const parent = row.parent_id ? byId.get(row.parent_id) : null;
            return !(parent && (parent.archived || parent.archived_at));
        })
        .sort(newestFirst)
        .map((row) => {
            const parent = row.parent_id ? byId.get(row.parent_id) : null;
            return {
                id: row.category_id,
                name: row.name || '',
                archivedAt: row.archived_at || null,
                parentName: parent ? parent.name || '' : null,
                inside: archived
                    .filter((sub) => sub.parent_id === row.category_id)
                    .map((sub) => ({ id: sub.category_id, name: sub.name || '' })),
            };
        });
}

/** "Sales › Pricing" for a page summary's location, or "" when it has none. */
export function pageLocationLabel(page) {
    return page ? wikiPathLabel(page.category_name, page.subcategory_name) : '';
}
